import { render, staticRenderFns } from "./ProductsPromo.vue?vue&type=template&id=6eae35a7&scoped=true&"
import script from "./ProductsPromo.vue?vue&type=script&lang=ts&"
export * from "./ProductsPromo.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsPromo.vue?vue&type=style&index=0&id=6eae35a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eae35a7",
  null
  
)

export default component.exports